/** CORTEKITANCHO | CORTEKITALTO | CORTEKITFONDO | CORTEKITESP y variantes */
export function isCorteKitCatalog(codigoOrCatalogID?: string | number | null): boolean {
  if (codigoOrCatalogID == null || codigoOrCatalogID === '') return false
  return String(codigoOrCatalogID).toUpperCase().startsWith('CORTEKIT')
}

export function itemUsesCorteKitCatalog(item?: {
  catalogID?: string | number | null
  codigo?: string | null
} | null): boolean {
  if (item == null) return false
  return isCorteKitCatalog(item.catalogID) || isCorteKitCatalog(item.codigo)
}

export type CutKitDimension = 'Alto' | 'Ancho' | 'Fondo'

const CUT_KIT_EPS_MM = 0.5

function morphCatalogMm(
  item: { morphs?: Array<{ name?: string; default?: number; _default?: number }> },
  name: CutKitDimension,
): number | null {
  const morph = item.morphs?.find((entry) => entry.name === name)
  const baseline = Number(morph?._default)
  if (Number.isFinite(baseline) && baseline > 0) return baseline
  return null
}

function catalogMm(
  item: {
    morphs?: Array<{ name?: string; default?: number; _default?: number }>
    freeDimensionCatalogMm?: { x?: number; y?: number; z?: number }
  },
  name: CutKitDimension,
): number | null {
  const fromCatalog =
    name === 'Ancho'
      ? Number(item.freeDimensionCatalogMm?.x)
      : name === 'Alto'
        ? Number(item.freeDimensionCatalogMm?.y)
        : Number(item.freeDimensionCatalogMm?.z)
  if (Number.isFinite(fromCatalog) && fromCatalog > 0) return fromCatalog
  return morphCatalogMm(item, name)
}

function currentMm(
  item: { width?: number; height?: number; thickness?: number },
  name: CutKitDimension,
): number | null {
  const value =
    name === 'Ancho' ? Number(item.width) : name === 'Alto' ? Number(item.height) : Number(item.thickness)
  return Number.isFinite(value) && value > 0 ? value : null
}

/** Dimensiones que el usuario ha sacado del valor de catálogo. */
export function getChangedCutKitDimensions(item: {
  width?: number
  height?: number
  thickness?: number
  morphs?: Array<{ name?: string; default?: number; _default?: number }>
  freeDimensionCatalogMm?: { x?: number; y?: number; z?: number }
}): CutKitDimension[] {
  const changed: CutKitDimension[] = []
  for (const name of ['Ancho', 'Alto', 'Fondo'] as CutKitDimension[]) {
    const catalog = catalogMm(item, name)
    const current = currentMm(item, name)
    if (catalog == null || current == null) continue
    if (Math.abs(current - catalog) > CUT_KIT_EPS_MM) changed.push(name)
  }
  return changed
}

export function getCutKitCatalogId(changed: CutKitDimension[]): string | null {
  if (changed.length === 0) return null
  if (changed.length > 1) return 'CORTEKITESP'
  if (changed[0] === 'Alto') return 'CORTEKITALTO'
  if (changed[0] === 'Ancho') return 'CORTEKITANCHO'
  if (changed[0] === 'Fondo') return 'CORTEKITFONDO'
  return 'CORTEKITESP'
}
